import React, { useState } from "react";
import { FiX } from "react-icons/fi";
import { Avatar, Button, Divider } from "@heroui/react";
import {
  ArchiveBoxIcon,
  ArrowRightEndOnRectangleIcon,
  Squares2X2Icon,
} from "@heroicons/react/24/outline";
import { useAuth } from "@/contexts/AuthContext";
import { Link, useLocation } from "react-router-dom";
import ConfirmationModal from "@/components/modal/ConfirmationModal";

type TrainerSidebarProps = {
  title: string;
  isOpen: boolean;
};

const TrainerSidebar: React.FC<TrainerSidebarProps> = ({ title, isOpen }) => {
  const { logout, currentUser } = useAuth();
  const location = useLocation();
  const [trainerName, setTrainerName] = useState(
    currentUser?.name ? `Welcome, ${currentUser.name}!` : "Welcome!"
  );
  const [isLogoutOpen, setIsLogoutOpen] = useState(false);

  const sidebarLinks = [
    {
      id: 6,
      name: "Active Cohorts",
      path: "/active-cohorts",
      icon: <Squares2X2Icon />,
    },
    {
      id: 7,
      name: "Completed Cohorts",
      path: "/completed-cohorts",
      icon: <ArchiveBoxIcon />,
    },
  ];
  return (
    <div className="fixed top-0 z-40 flex flex-col justify-between h-full w-[320px] shadow-md p-6 overflow-y-auto transition-all duration-300 ease-in-out bg-white">
      <div>
        <div>
          <img
            src="/assets/images/logo/logo.png"
            alt="Logo"
            className="h-11 w-auto mb-4"
          />
          <button className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 p-1 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-300 lg:hidden">
            <FiX size={20} />
          </button>
        </div>
        <Divider className="h-0.5 bg-gray-200 " />
        <input
          type="text"
          value={trainerName}
          onChange={(e) => setTrainerName(e.target.value)}
          className="my-4 text-xl font-bold leading-none text-gray-500 border-none p-2 rounded w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="Enter Company Name"
        />
        <Divider className="h-0.5 bg-gray-200 " />
        <div className="flex flex-col gap-2 py-6">
          {sidebarLinks.map((link) => {
            const isActive = location.pathname === link.path;
            return (
              <Link
                key={link.id}
                to={link.path}
                className={`flex items-center p-4 rounded-xl hover:bg-blueLight-100 hover:text-blueDark ${
                  isActive
                    ? "bg-blueLight text-blueDark"
                    : "text-gray-900 hover:bg-gray-200"
                }`}
              >
                <div
                  className={`mr-3 text-2xl w-7 h-7  ${
                    isActive ? "text-blueDark" : "text-gray-400"
                  }`}
                >
                  {link.icon}
                </div>
                {link.name}
              </Link>
            );
          })}
        </div>
      </div>
      <div>
        <Divider className="bg-gray-200 h-0.5 my-4" />
        <div className="flex gap-2 justify-between items-center mt-4 w-full">
          <div className="flex gap-3 items-center self-stretch my-auto font-bold text-gray-900 min-w-0">
            <Avatar
              name={currentUser?.name ? currentUser.name.charAt(0) : "U"}
              className="bg-blueLight text-blueDark font-medium shrink-0"
            />

            <span className="self-stretch my-auto text-gray-900 text-xs truncate max-w-[80px] xl:max-w-[100px]">
              {currentUser?.name || "User"}
            </span>
          </div>

          <Button
            className="w-auto !p-0 flex items-center gap-3 bg-transparent hover:border-transparent border-transparent text-base !text-grayColor font-medium shrink-0"
            onPress={() => setIsLogoutOpen(true)}
          >
            Logout
            <ArrowRightEndOnRectangleIcon className="w-8 h-8 font-bold text-grayColor" />
          </Button>
        </div>
      </div>
      <ConfirmationModal isOpen={isLogoutOpen} onOpenChange={setIsLogoutOpen}>
        <div className="text-lg font-semibold mb-3">
          Are you Sure want to Logout?
        </div>
        <div className="flex justify-end  gap-2">
          <Button onPress={() => setIsLogoutOpen(false)}>No</Button>
          <Button
            variant="solid"
            className="bg-grayColor text-white"
            onPress={() => logout()}
          >
            Yes
          </Button>
        </div>
      </ConfirmationModal>
    </div>
  );
};

export default TrainerSidebar;
